module.exports = __webpack_public_path__ + "static/media/banner.a6708be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner.jpg
// module id = 1105
// module chunks = 2